/* @flow */
// typecheck: ignore file
import React from 'react';
import AuthActions from 'auth/AuthActions';
import CenteredContainer from 'components/CenteredContainer.jsx';
import DeviceActions from 'actions/DeviceActions';
import DeviceStore from 'stores/DeviceStore';
import EventTracking from 'lib/EventTracking';
import ParentalConsentOptionView from 'user/components/ParentalConsentOptionView.jsx';
import ParentalConsentOptionsView from 'user/components/ParentalConsentOptionsView.jsx';
import View from 'components/View.jsx';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const EVENT_SCREEN_NAME = 'vpc_flow';

type Props = {
  location: Object
};

type State = {
  childId: number,
  childName: string,
  option: string,
};

class ParentalConsentPage extends React.Component {
  props: Props;
  state: State;

  static propTypes = {
    location: React.PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static childContextTypes = {
    eventContextName: React.PropTypes.string,
    eventScreenName: React.PropTypes.string,
  };

  // This has to be here in order to get a CurrentUser
  static onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
    AuthActions.accessTokenSignIn(nextState.location.query.token)
    .then(DeviceActions.loadDevices)
    .then(callback)
    .catch(callback);
  }

  constructor(props: Props) {
    super(props);
    const { query } = props.location;

    this.state = {
      childId: parseInt(query['child_id'], 10),
      childName: query['child_name'],
      option: this.chooseViewOption(),
    };
  }

  getChildContext() {
    const { referrer } = this.props.location.query;

    return {
      eventContextName: referrer,
      eventScreenName: EVENT_SCREEN_NAME,
    };
  }

  componentDidMount() {
    EventTracking.view(EVENT_SCREEN_NAME, { uiContext: this.props.location.query.referrer });
  }

  // If there's no email associated with the current user, only show card option
  chooseViewOption() {
    const devices = DeviceStore.getDevices();
    const option = devices.type('email').length === 0 ? 'card' : '';
    return option;
  }

  setOption = (option: string) => {
    this.setState({ option });
  };

  proceed = () => {
    this.context.router.push('/setup');
  };

  renderBody = () => {
    const { childId, childName, option } = this.state;

    if (option) {
      return (
        <ParentalConsentOptionView
          childId={childId}
          option={option}
          setOption={this.setOption}
          onProceed={this.proceed}
        />
      );
    } else {
      return (
        <ParentalConsentOptionsView
          childName={childName}
          setOption={this.setOption}
          onProceed={this.proceed}
        />
      );
    }
  };

  render() {
    return (
      <div className="ParentalConsentPage">
        <CenteredContainer>
          <View>
            {this.renderBody()}
          </View>
        </CenteredContainer>
      </div>
    );
  }
}

export default ParentalConsentPage;



// WEBPACK FOOTER //
// ./src/user/components/ParentalConsentPage.jsx